<template>
  <div>
    <div class="flex justify-between">
      <GrmBtn color="gray" @click="() => SET_VIEW('testbank__exam_list')">{{ $t("testBank.goBack") }}</GrmBtn>
      <GrmBtn @click="onEditExam">{{ $t("testBank.edit") }}</GrmBtn>
    </div>
    <div class="mt-4 -mx-3 py-8 px-10 bg-gray-100 lg:mt-10 lg:-mx-10 lg:px10">
      <div class="flex flex-col gap-y-6">
        <div>
          <p class="w-max border border-blue-400 rounded-xl px-3 bg-white text-sm text-blue-400 leading-6">{{ $t("testBank.style") }}</p>
          <div class="mt-3">
            <GrmBtn :color="testbankExam?.examType === 'QUIZ' ? 'purple' : 'green'"
                    hoverColor="none"
                    disabled
            >{{ testbankExam?.examType === 'QUIZ' ? $t('testBank.write') : $t('testBank.survey') }}</GrmBtn>
          </div>
        </div>
        <div>
          <div class="w-max border border-blue-400 rounded-xl px-3 bg-white text-sm text-blue-400 leading-6">{{ $t("setting.name.title") }}</div>
          <p class="mt-3">
            <GrmTextField class="w-full" v-model="testbankExam.examTitle" ref="examTitle" disabled />
          </p>
        </div>
        <div v-if="testbankExam?.examType === 'QUIZ'" class="border-t border-gray-300 pt-6 flex flex-col items-center">
          <p class="font-bold">{{ $t("testBank.answerTable") }}</p>
          <TestbankResultCorrectTable class="mt-4" :questionList="testbankExam?.questionList" />
        </div>
      </div>
    </div>

    <TestbankQuestionList :questionList="testbankExam?.questionList" />
  </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";

import GrmBtn from "@/components/Common/button/GrmBtn.vue";
import GrmTextField from "@/components/Common/textField/GrmTextField.vue";
import TestbankQuestionList from "@/components/Room/Testbank/Question/TestbankQuestionList.vue";
import TestbankResultCorrectTable from "@/components/Room/Testbank/Result/TestbankResultCorrectTable.vue";

export default {
  name: 'RoomExam',
  components: {
    GrmBtn,
    GrmTextField,
    TestbankQuestionList,
    TestbankResultCorrectTable,
  },
  computed: {
    ...mapState('testbank', [
      'testbankExam',
      'testbankExamList',
    ]),

    examTypeColor() {
      return this.testbankObj.examType === 'QUIZ' ? 'purple' : 'green'
    }
  },
  created() {
    this.getTestbankExam();
  },
  methods: {
    ...mapMutations('exam', [
      'SET_TESTBANK_EXAM',
    ]),
    ...mapMutations('testbank', [
      'SET_VIEW',
    ]),
    ...mapActions('testbank', [
      'getTestbankExam',
      'createTestbankExam',
    ]),

    onEditExam() {
      this.SET_VIEW('testbank__exam_edit');
    },
    onMoveQuestion(questionNum) {
      document.querySelector(`#question_${questionNum}`).scrollIntoView();
    }
  }
}
</script>

<style lang="scss" scoped>
.room-exam-create {
  padding-bottom: 40px;
}
.room-exam-create-body {
  margin-top: 40px;
}
.room-exam-create-footer {
  margin-top: 40px;
  display: flex;
  justify-content: center;
}
.room-exam-create-button-container {
  display: flex;
  gap: 0 10px;
}
.room-exam-create-button {
  transition: 0.1s ease-out;
  &.add {
    padding: 0 60px;
    font-size: 14px;
    color: #fff;
    line-height: 40px;
    &.obj {
      background: #737898 url('~@/assets/images/exam_obj_white.svg') no-repeat center left 10px / 20px auto;
      &:hover {
        background: #1bc1c1 url('~@/assets/images/exam_obj_white.svg') no-repeat center left 10px / 20px auto;
      }
    }
    &.sub {
      background: #737898 url('~@/assets/images/exam_sub_white.svg') no-repeat center left 10px / 20px auto;
      &:hover {
        background: #f90 url('~@/assets/images/exam_sub_white.svg') no-repeat center left 10px / 20px auto;
      }
    }
    &:hover {
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4);
    }
  }
}
</style>